<template>
  <div class="table-panel">
    <div class="table-entry">
      <span class="table-entry-name">SUM</span>
      <span class="table-entry-value">{{ sum }}</span>
    </div>
    <div class="table-entry">
      <span class="table-entry-name">AVERAGE</span>
      <span class="table-entry-value">{{ average }}</span>
    </div>
    <div class="table-entry">
      <span class="table-entry-name">MIN</span>
      <span class="table-entry-value">{{ min }}</span>
    </div>
    <div class="table-entry">
      <span class="table-entry-name">MAX</span>
      <span class="table-entry-value">{{ max }}</span>
    </div>
    <div class="table-entry">
      <span class="table-entry-name">COUNTA</span>
      <span class="table-entry-value">{{ counta }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatisticsTable',

  props: {
    data: Array,
    column: String
  },

  data () {
    let min = Number.POSITIVE_INFINITY
    let max = Number.NEGATIVE_INFINITY
    let sum = 0
    let divider = 0
    let count = 0

    this.data.forEach(row => {
      if (row[this.column]) {
        count += 1
      }
      if (typeof row[this.column] === 'number') {
        if (row[this.column] > max) {
          max = row[this.column]
        }
        if (row[this.column] < min) {
          min = row[this.column]
        }
        sum += row[this.column]
        divider += 1
      }
    })

    return {
      min: min,
      max: max,
      sum: sum,
      average: (sum / divider).toFixed(2),
      counta: count
    }
  }
}
</script>

<style scoped>
  .table-panel {
    width: 100%;
    height: 100%;
  }

  .table-entry:nth-child(odd) {
    background: var(--color-light-gray);
  }

  .table-entry {
    line-height: 30px;
    padding: 0 8px;
  }

  .table-entry-name {
    font-weight: bold;
  }

  .table-entry-value {
    float: right;
  }
</style>
